













































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxCheckBox, DxSelectBox, DxNumberBox, DxScrollView } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
// import subcontractorsRepository from '@/services/subcontractorsRepository';
// import companiesRepository from '@/services/companiesRepository';
import contactsRepository from '@/services/contactsRepository';
import cPopup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxTab, DxTabbedItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor, DxToolbar } from 'devextreme-vue/html-editor';

import {
  Address,
  ContactsClient,
  CreateCompanyCommand,
  CreateSubcontractorCommand,
  TunnelGroupsClient,
  ITunnelGroup,
  UpdateCompanyCommand,
  UpdateSubcontractorCommand,
  ZipClient,
} from '@/data/web-api-client';
import { DxItem as DxHtmlEditorItem } from 'devextreme-vue/html-editor';
import DxButton from 'devextreme-vue/button';
import axios from 'axios';
import Subcontractor from '@/classes/CRM/Subcontractor';

@Component({
  components: {
    DxCheckBox,
    DxSelectBox,
    DxNumberBox,
    DxSimpleItem,
    DxGroupItem,
    DxForm,
    DxLabel,
    DxItem,
    DxTextArea,
    DxScrollView,
    DxRequiredRule,
    DxTab,
    DxTabbedItem,
    DxHtmlEditor,
    DxHtmlEditorItem,
    DxToolbar,
    cPopup,
    DxButton,
  },
})
export default class CompanyDetailsDialog extends Vue {
  @Prop({ required: true })
  public company!: ICompany;

  public show: boolean = false;
  public saving: boolean = false;
  public checkVat: boolean = false;
  public checkingVat: boolean = false;

  private sizeValues: any[] = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
  private tunnelGroups: ITunnelGroup[] = [];
  private contactClient = new ContactsClient(undefined, this.$axios);

  private async mounted() {
    await this.loadTunnelGroups();
  }

  get title() {
    return this.company && this.company.id ? this.$t(`objects.companies.titles.EditTitle`) : this.$t(`objects.companies.titles.AddTitle`);
  }

  get specialtyOptions() {
    return { items: this.$store.getters['catalogs/list']('WorkTypes').values };
  }

  get languageOptions() {
    const list = this.$store.getters['catalogs/list']('Languages');

    if (list) {
      return { items: list.values };
    }
  }

  get tagsOptions() {
    return {
      items: this.$store.getters['catalogs/list']('SubcontractorTags').values,
    };
  }

  get tunnelGroupsOptions() {
    const items = this.tunnelGroups.map((dg) => ({
      value: dg.id,
      text: dg.name,
    }));

    return {
      dataSource: items,
      showClearButton: true,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }

  public async save() {
    try {
      const form: any = this.$refs.companyDetailsForm;
      const validationResult = form.instance.validate();
      let result: any = null;

      if (!validationResult.isValid) {
        notificationService.invalidForm();

        return;
      }

      this.saving = true;

      if (this.company.type === 'Subcontractor') {
        const subcontractor = this.company as Subcontractor;

        if (this.company.id) {
          const command = new UpdateSubcontractorCommand({
            id: subcontractor.id,
            disabled: false,
            companyName: subcontractor.companyName,
            vatNumber: subcontractor.vatNumber,
            email: subcontractor.email,
            phone: subcontractor.phone,
            contantPaymentTerms: (subcontractor as any).contantPaymentTerms,
            language: subcontractor.language,
            tags: subcontractor.tags,
            notes: subcontractor.notes,
            specialty: subcontractor.specialty,
            addresses: subcontractor.addresses.map(
              (a) =>
                new Address({
                  name: a.name,
                  addressline1: a.addressline1,
                  addressline2: a.addressline2,
                  type: a.type,
                  city: a.city,
                  country: a.country,
                })
            ),
            tunnelGroupsId: subcontractor.tunnelGroupsId,
          });

          result = {};
          result.data = await this.contactClient.updateSubcontractor(command);
        } else {
          const command = new CreateSubcontractorCommand({
            companyName: subcontractor.companyName,
            vatNumber: subcontractor.vatNumber,
            email: subcontractor.email,
            phone: subcontractor.phone,
            contantPaymentTerms: (subcontractor as any).contantPaymentTerms,
            language: subcontractor.language,
            tags: subcontractor.tags,
            specialty: subcontractor.specialty,
            addresses: subcontractor.addresses.map(
              (a) =>
                new Address({
                  name: a.name,
                  addressline1: a.addressline1,
                  addressline2: a.addressline2,
                  type: a.type,
                  city: a.city,
                  country: a.country,
                })
            ),
            tunnelGroupsId: subcontractor.tunnelGroupsId,
          });

          result = {};
          result.data = await this.contactClient.createSubcontractor(command);
        }
      } else {
        result = this.company.id ? await contactsRepository.update(this.company) : await contactsRepository.create(this.company);
      }

      notificationService.saved();
      this.$emit('updated', result.data);
      this.show = false;
    } catch (err) {
      notificationService.failedToSave();
    } finally {
      this.saving = false;
    }
  }

  private fillInAddress(vatNumberResponseObject: any) {
    if (this.company.companyName === '') {
      this.company.companyName = vatNumberResponseObject.data.companyName;
    }
    if (this.company.addresses === null || this.company.addresses.length == 0) {
      this.company.addresses = [];
      var address = {
        name: 'default',
        type: 0,
        addressline1: vatNumberResponseObject.data.streetAndNumber,
        addressline2: '',
        zip: vatNumberResponseObject.data.postalCode,
        city: vatNumberResponseObject.data.city,
        country: '',
      };
      this.company.addresses.push(address);
    }
  }

  get vatOptions() {
    const self = this;
    return {
      onChange() {
        if (self.company.vatNumber) {
          self.checkVat = true;
        }
      },
    };
  }

  get buttonOptions() {
    const self = this;
    return {
      text: 'Controleer BTW nummer',
      type: 'success',
      icon: self.checkingVat ? 'fas fa-spin fa-spinner' : 'fas fa-check',
      onClick() {
        self.checkVatNumber();
      },
    };
  }

  public async checkVatNumber() {
    var vatNumberResponseObject;
    if (this.company.vatNumber) {
      this.checkingVat = true;
      vatNumberResponseObject = await contactsRepository.checkVatNumber(this.company.vatNumber);
    }
    if (vatNumberResponseObject && vatNumberResponseObject.data.valid == true) {
      this.fillInAddress(vatNumberResponseObject);
      notificationService.showSuccessMessage('BTW nummer geldig!');
      this.checkVat = false;
    } else {
      notificationService.showErrorMessage('BTW nummer niet geldig!');
    }
    this.checkingVat = false;
  }

  private async loadTunnelGroups() {
    this.tunnelGroups = await new TunnelGroupsClient(undefined, axios).get();
  }

  get zipOptions() {
    const self = this;
    return {
      onChange: async (e: any) => {
        var result = await new ZipClient(undefined, self.$axios).getCityByZip(self.company!.addresses![0].zip);
        if (result) {
          self.company!.addresses![0].city = result.hoofdgemeente!;
        } else {
          self.company!.addresses![0].city = '';
        }
      },
    };
  }

  get tabbedContent() {
    return [
      {
        itemType: 'tabbed',
        tabPanelOptions: {
          deferRendering: false,
        },
        tabs: [
          // ADDRESS
          {
            title: this.$t('objects.contacts.Subtitles.Address'),
            items: [
              {
                itemType: 'simple',
                dataField: 'address.addressline1',
                label: {
                  text: this.$t('objects.address.Addressline1'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.zip',
                editorOptions: this.zipOptions,
                label: {
                  text: this.$t('objects.address.Zip'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.city',
                label: {
                  text: this.$t('objects.address.City'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.country',
                label: {
                  text: this.$t('objects.address.Country'),
                },
              },
            ],
          },
          // IDENTITY INFORMATION
          {
            title: this.$t('objects.contacts.Subtitles.IdentityInformation'),
            items: [
              {
                itemType: 'simple',
                dataField: 'dateOfBirth',
                editorType: 'dxDateBox',
                editorOptions: { width: '100%' },
                label: {
                  text: this.$t('objects.contacts.Fields.DateOfBirth'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'birthLocation',
                label: {
                  text: this.$t('objects.contacts.Fields.BirthLocation'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'socialSecurityNumber',
                label: {
                  text: this.$t('objects.contacts.Fields.SocialSecurityNumber'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'nationalInsuranceNumber',
                label: {
                  text: this.$t('objects.contacts.Fields.NationalInsuranceNumber'),
                },
              },
              {
                itemType: 'simple',
                dataField: 'nationality',
                label: {
                  text: this.$t('objects.contacts.Fields.Nationality'),
                },
              },
            ],
          },
          // Notes
          {
            title: this.$t('objects.contacts.Subtitles.Notes'),
            items: [
              {
                itemType: 'simple',
                dataField: 'notes',
                editorType: 'dxTextArea',
                editorOptions: { height: 100 },
                label: {
                  text: this.$t('objects.contacts.Fields.Notes'),
                },
              },
            ],
          },
          // Invoicing
          {
            title: 'Kortingen',
            items: [
              {
                itemType: 'simple',
                dataField: 'billingDetails.discountPercentage',
                editorType: 'dxNumberBox',
                label: {
                  text: 'Korting (%)',
                },
              },
            ],
          },
        ],
      },
    ];
  }
}
